
import { useState, useEffect } from 'react';

// Declare TikTok Pixel types
declare global {
  interface Window {
    ttq: {
      track: (event: string, data?: Record<string, unknown>) => void;
      page: () => void;
    };
  }
}

export default function Home() {
  const [selectedRecipe, setSelectedRecipe] = useState<number | null>(null);
  const [showNewsletter, setShowNewsletter] = useState(false);
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  // Track page view on mount
  useEffect(() => {
    if (window.ttq) {
      window.ttq.track('ViewContent', {
        content_type: 'recipe_website',
        content_name: 'Receitas de Bolo Fitness'
      });
    }
  }, []);

  const recipes = [
    {
      id: 1,
      name: 'Bolo de Chocolate Fit',
      description: 'Delicioso bolo de chocolate sem açúcar, feito com cacau 100% e adoçante natural. Perfeito para quem busca uma sobremesa saudável sem abrir mão do sabor.',
      image: 'https://public.readdy.ai/ai/img_res/452e9eec8cc1ddbc16ec040c75f5602b.jpg',
      prepTime: '40 min',
      calories: '180 kcal',
      protein: '12g',
      difficulty: 'Fácil',
      ingredients: [
        '3 ovos',
        '1 xícara de farinha de aveia',
        '1/2 xícara de cacau em pó 100%',
        '1/2 xícara de adoçante culinário',
        '1/2 xícara de leite desnatado',
        '1/4 xícara de óleo de coco',
        '1 colher de sopa de fermento em pó'
      ],
      instructions: [
        'Pré-aqueça o forno a 180°C',
        'Bata os ovos com o adoçante até ficar cremoso',
        'Adicione o leite e o óleo de coco',
        'Misture a farinha de aveia e o cacau peneirados',
        'Por último, adicione o fermento',
        'Despeje em forma untada',
        'Asse por 35-40 minutos'
      ]
    },
    {
      id: 2,
      name: 'Bolo de Banana Proteico',
      description: 'Bolo úmido e saboroso feito com bananas maduras e whey protein. Rico em proteínas e fibras, ideal para o pós-treino ou café da manhã.',
      image: 'https://readdy.ai/api/search-image?query=healthy%20banana%20protein%20fitness%20cake%20slice%20on%20white%20plate%20minimalist%20clean%20background%20natural%20lighting%20food%20photography%20professional%20high%20quality%20detailed%20texture%20moist%20cake%20with%20banana&width=800&height=600&seq=rec2&orientation=landscape',
      prepTime: '35 min',
      calories: '165 kcal',
      protein: '15g',
      difficulty: 'Fácil',
      ingredients: [
        '3 bananas maduras',
        '2 ovos',
        '1 xícara de farinha de aveia',
        '2 scoops de whey protein de baunilha',
        '1/4 xícara de mel',
        '1/4 xícara de óleo de coco',
        '1 colher de sopa de fermento',
        '1 colher de chá de canela'
      ],
      instructions: [
        'Amasse as bananas com um garfo',
        'Misture os ovos, mel e óleo de coco',
        'Adicione a farinha de aveia e o whey protein',
        'Acrescente a canela e o fermento',
        'Despeje em forma untada',
        'Asse a 180°C por 30-35 minutos'
      ]
    },
    {
      id: 3,
      name: 'Bolo de Cenoura Light',
      description: 'Versão fitness do clássico bolo de cenoura, com cobertura de chocolate fit. Sem açúcar refinado e com ingredientes naturais.',
      image: 'https://readdy.ai/api/search-image?query=healthy%20carrot%20fitness%20cake%20with%20chocolate%20topping%20slice%20on%20white%20plate%20minimalist%20clean%20background%20natural%20lighting%20food%20photography%20professional%20high%20quality%20detailed%20texture%20moist%20orange%20cake&width=800&height=600&seq=rec3&orientation=landscape',
      prepTime: '45 min',
      calories: '195 kcal',
      protein: '10g',
      difficulty: 'Médio',
      ingredients: [
        '3 cenouras médias',
        '3 ovos',
        '1 xícara de farinha de aveia',
        '1/2 xícara de adoçante',
        '1/4 xícara de óleo de coco',
        '1 colher de sopa de fermento',
        'Para cobertura: 2 colheres de cacau + 2 colheres de mel'
      ],
      instructions: [
        'Bata no liquidificador as cenouras, ovos e óleo',
        'Transfira para uma tigela',
        'Adicione a farinha de aveia e o adoçante',
        'Misture o fermento por último',
        'Asse a 180°C por 40 minutos',
        'Prepare a cobertura misturando cacau e mel',
        'Cubra o bolo ainda quente'
      ]
    },
    {
      id: 4,
      name: 'Bolo de Limão Fit',
      description: 'Bolo refrescante de limão com baixo teor calórico. Leve, úmido e perfeito para os dias quentes. Sem glúten e sem lactose.',
      image: 'https://readdy.ai/api/search-image?query=healthy%20lemon%20fitness%20cake%20slice%20on%20white%20plate%20minimalist%20clean%20background%20natural%20lighting%20food%20photography%20professional%20high%20quality%20detailed%20texture%20moist%20yellow%20cake%20with%20lemon&width=800&height=600&seq=rec4&orientation=landscape',
      prepTime: '35 min',
      calories: '155 kcal',
      protein: '8g',
      difficulty: 'Fácil',
      ingredients: [
        '3 ovos',
        '1 xícara de farinha de amêndoas',
        'Suco de 2 limões',
        'Raspas de 1 limão',
        '1/2 xícara de adoçante',
        '1/4 xícara de óleo de coco',
        '1 colher de sopa de fermento'
      ],
      instructions: [
        'Bata os ovos com o adoçante',
        'Adicione o suco e as raspas de limão',
        'Misture o óleo de coco',
        'Incorpore a farinha de amêndoas',
        'Adicione o fermento',
        'Asse a 180°C por 30-35 minutos'
      ]
    },
    {
      id: 5,
      name: 'Bolo de Coco Proteico',
      description: 'Bolo tropical de coco com alto teor de proteína. Textura macia e sabor intenso de coco. Perfeito para quem ama coco!',
      image: 'https://readdy.ai/api/search-image?query=healthy%20coconut%20protein%20fitness%20cake%20slice%20on%20white%20plate%20minimalist%20clean%20background%20natural%20lighting%20food%20photography%20professional%20high%20quality%20detailed%20texture%20moist%20white%20cake%20with%20coconut&width=800&height=600&seq=rec5&orientation=landscape',
      prepTime: '40 min',
      calories: '175 kcal',
      protein: '14g',
      difficulty: 'Fácil',
      ingredients: [
        '3 ovos',
        '1 xícara de farinha de coco',
        '2 scoops de whey protein de coco',
        '1/2 xícara de leite de coco',
        '1/2 xícara de adoçante',
        '1/4 xícara de óleo de coco',
        '1/2 xícara de coco ralado',
        '1 colher de sopa de fermento'
      ],
      instructions: [
        'Bata os ovos com o adoçante',
        'Adicione o leite de coco e o óleo',
        'Misture a farinha de coco e o whey',
        'Acrescente o coco ralado',
        'Adicione o fermento',
        'Asse a 180°C por 35-40 minutos'
      ]
    },
    {
      id: 6,
      name: 'Bolo Red Velvet Fit',
      description: 'Versão saudável do famoso red velvet. Cor vibrante natural de beterraba, sem corantes artificiais. Cobertura de cream cheese fit.',
      image: 'https://readdy.ai/api/search-image?query=healthy%20red%20velvet%20fitness%20cake%20slice%20on%20white%20plate%20minimalist%20clean%20background%20natural%20lighting%20food%20photography%20professional%20high%20quality%20detailed%20texture%20moist%20red%20cake%20with%20white%20frosting&width=800&height=600&seq=rec6&orientation=landscape',
      prepTime: '50 min',
      calories: '190 kcal',
      protein: '11g',
      difficulty: 'Médio',
      ingredients: [
        '1 beterraba pequena cozida',
        '3 ovos',
        '1 xícara de farinha de aveia',
        '2 colheres de cacau em pó',
        '1/2 xícara de adoçante',
        '1/4 xícara de óleo de coco',
        '1 colher de sopa de fermento',
        'Para cobertura: cream cheese light + adoçante'
      ],
      instructions: [
        'Bata a beterraba com os ovos no liquidificador',
        'Adicione o óleo e o adoçante',
        'Misture a farinha de aveia e o cacau',
        'Adicione o fermento',
        'Asse a 180°C por 40 minutos',
        'Prepare a cobertura batendo cream cheese com adoçante',
        'Cubra o bolo frio'
      ]
    }
  ];

  const handleRecipeClick = (id: number) => {
    setSelectedRecipe(id);
    if (window.ttq) {
      window.ttq.track('ClickButton', {
        content_type: 'recipe',
        content_id: `recipe_${id}`,
        button_name: 'Ver Receita'
      });
    }
  };

  const handleNewsletterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubscribed(true);
    if (window.ttq) {
      window.ttq.track('Subscribe', {
        content_type: 'newsletter',
        email: email
      });
    }
    setTimeout(() => {
      setShowNewsletter(false);
      setSubscribed(false);
      setEmail('');
    }, 2000);
  };

  const selectedRecipeData = recipes.find(r => r.id === selectedRecipe);

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="sticky top-0 z-40 bg-white/95 backdrop-blur-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-xl">
                <i className="ri-cake-3-line text-2xl text-white"></i>
              </div>
              <div>
                <h1 className="text-xl font-bold text-gray-900">Bolos Fitness</h1>
                <p className="text-xs text-gray-500">Receitas saudáveis e deliciosas</p>
              </div>
            </div>
            <button
              onClick={() => setShowNewsletter(true)}
              className="px-4 py-2 bg-gradient-to-r from-[#FF6B6B] to-[#FF8E53] text-white rounded-lg text-sm font-semibold hover:shadow-lg transition-all cursor-pointer whitespace-nowrap"
            >
              Receber Receitas
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#FFF5F5] via-white to-[#FFF8F0] py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm mb-6">
              <div className="w-2 h-2 bg-[#FF6B6B] rounded-full animate-pulse"></div>
              <span className="text-sm font-medium text-gray-700">100% Receitas Saudáveis</span>
            </div>
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              Bolos Deliciosos e
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FF6B6B] to-[#FF8E53]"> Fitness</span>
            </h2>
            <p className="text-lg sm:text-xl text-gray-600 mb-8 leading-relaxed">
              Descubra receitas incríveis de bolos fitness que vão transformar sua alimentação. Sabor e saúde em cada fatia! 🍰
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <div className="flex items-center gap-2 bg-white px-4 py-3 rounded-xl shadow-sm">
                <div className="w-8 h-8 flex items-center justify-center bg-green-100 rounded-lg">
                  <i className="ri-heart-pulse-line text-lg text-green-600"></i>
                </div>
                <div className="text-left">
                  <div className="text-xs text-gray-500">Baixas Calorias</div>
                  <div className="text-sm font-bold text-gray-900">155-195 kcal</div>
                </div>
              </div>
              <div className="flex items-center gap-2 bg-white px-4 py-3 rounded-xl shadow-sm">
                <div className="w-8 h-8 flex items-center justify-center bg-blue-100 rounded-lg">
                  <i className="ri-flashlight-line text-lg text-blue-600"></i>
                </div>
                <div className="text-left">
                  <div className="text-xs text-gray-500">Alto em Proteína</div>
                  <div className="text-sm font-bold text-gray-900">8-15g por fatia</div>
                </div>
              </div>
              <div className="flex items-center gap-2 bg-white px-4 py-3 rounded-xl shadow-sm">
                <div className="w-8 h-8 flex items-center justify-center bg-purple-100 rounded-lg">
                  <i className="ri-time-line text-lg text-purple-600"></i>
                </div>
                <div className="text-left">
                  <div className="text-xs text-gray-500">Preparo Rápido</div>
                  <div className="text-sm font-bold text-gray-900">35-50 min</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Recipes Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h3 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              Nossas Receitas
            </h3>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Escolha sua receita favorita e comece a preparar bolos deliciosos e saudáveis hoje mesmo!
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {recipes.map((recipe) => (
              <div
                key={recipe.id}
                className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all overflow-hidden group cursor-pointer"
                onClick={() => handleRecipeClick(recipe.id)}
              >
                <div className="relative w-full h-64 overflow-hidden">
                  <img
                    src={recipe.image}
                    alt={recipe.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute top-4 right-4 bg-white px-3 py-1.5 rounded-full shadow-lg">
                    <span className="text-sm font-bold text-[#FF6B6B]">{recipe.calories}</span>
                  </div>
                </div>
                <div className="p-6">
                  <h4 className="text-xl font-bold text-gray-900 mb-2">{recipe.name}</h4>
                  <p className="text-sm text-gray-600 mb-4 line-clamp-2">{recipe.description}</p>
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-2">
                      <div className="w-6 h-6 flex items-center justify-center">
                        <i className="ri-time-line text-gray-500"></i>
                      </div>
                      <span className="text-sm text-gray-600">{recipe.prepTime}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="w-6 h-6 flex items-center justify-center">
                        <i className="ri-fire-line text-orange-500"></i>
                      </div>
                      <span className="text-sm text-gray-600">{recipe.protein}</span>
                    </div>
                    <div className="px-3 py-1 bg-green-100 rounded-full">
                      <span className="text-xs font-semibold text-green-700">{recipe.difficulty}</span>
                    </div>
                  </div>
                  <button className="w-full py-3 bg-gradient-to-r from-[#FF6B6B] to-[#FF8E53] text-white rounded-xl font-semibold hover:shadow-lg transition-all whitespace-nowrap">
                    Ver Receita Completa
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 bg-gradient-to-br from-[#FFF5F5] to-[#FFF8F0]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h3 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              Por que Bolos Fitness?
            </h3>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Descubra os benefícios de incluir bolos fitness na sua alimentação
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white rounded-2xl p-6 shadow-lg text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-green-100 to-green-200 rounded-2xl mx-auto mb-4">
                <i className="ri-leaf-line text-3xl text-green-600"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">Ingredientes Naturais</h4>
              <p className="text-sm text-gray-600">
                Sem açúcar refinado, sem conservantes. Apenas ingredientes naturais e saudáveis.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-blue-100 to-blue-200 rounded-2xl mx-auto mb-4">
                <i className="ri-heart-pulse-line text-3xl text-blue-600"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">Baixas Calorias</h4>
              <p className="text-sm text-gray-600">
                Perfeito para quem quer manter a forma sem abrir mão do sabor.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-purple-100 to-purple-200 rounded-2xl mx-auto mb-4">
                <i className="ri-flashlight-line text-3xl text-purple-600"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">Rico em Proteína</h4>
              <p className="text-sm text-gray-600">
                Ideal para pós-treino e para quem busca ganho de massa muscular.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-orange-100 to-orange-200 rounded-2xl mx-auto mb-4">
                <i className="ri-restaurant-line text-3xl text-orange-600"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">Sabor Incrível</h4>
              <p className="text-sm text-gray-600">
                Bolos deliciosos que não parecem ser fitness. Sabor garantido!
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-[#FF6B6B] to-[#FF8E53]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h3 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Receba Novas Receitas Toda Semana!
          </h3>
          <p className="text-lg text-white/90 mb-8">
            Cadastre-se e receba receitas exclusivas de bolos fitness direto no seu email
          </p>
          <button
            onClick={() => setShowNewsletter(true)}
            className="px-8 py-4 bg-white text-[#FF6B6B] rounded-xl font-bold text-lg hover:shadow-2xl transition-all cursor-pointer whitespace-nowrap"
          >
            Quero Receber Receitas Grátis
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-xl">
                  <i className="ri-cake-3-line text-2xl text-white"></i>
                </div>
                <span className="text-xl font-bold">Bolos Fitness</span>
              </div>
              <p className="text-gray-400 text-sm">
                Receitas saudáveis e deliciosas para você manter a forma sem abrir mão do sabor.
              </p>
            </div>

            <div>
              <h4 className="font-bold mb-4">Receitas</h4>
              <ul className="space-y-2 text-sm text-gray-400">
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Bolos de Chocolate</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Bolos de Frutas</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Bolos Proteicos</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Bolos Sem Glúten</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold mb-4">Contato</h4>
              <ul className="space-y-2 text-sm text-gray-400">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line"></i>
                  <span>contato@bolosfitness.com</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-instagram-line"></i>
                  <span>@bolosfitness</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-facebook-line"></i>
                  <span>/bolosfitness</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8 text-center">
            <p className="text-sm text-gray-400">
              © 2024 Bolos Fitness. Todos os direitos reservados. | <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </footer>

      {/* Recipe Modal */}
      {selectedRecipe && selectedRecipeData && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4 overflow-y-auto">
          <div className="bg-white w-full max-w-4xl rounded-3xl shadow-2xl my-8">
            <div className="relative w-full h-80 overflow-hidden rounded-t-3xl">
              <img
                src={selectedRecipeData.image}
                alt={selectedRecipeData.name}
                className="w-full h-full object-cover"
              />
              <button
                onClick={() => setSelectedRecipe(null)}
                className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-gray-100 cursor-pointer"
              >
                <i className="ri-close-line text-2xl text-gray-700"></i>
              </button>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-6">
                <h3 className="text-3xl font-bold text-white mb-2">{selectedRecipeData.name}</h3>
                <div className="flex items-center gap-4 text-white">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {selectedRecipeData.prepTime}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line"></i>
                    {selectedRecipeData.calories}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-flashlight-line"></i>
                    {selectedRecipeData.protein}
                  </span>
                </div>
              </div>
            </div>

            <div className="p-8 max-h-[60vh] overflow-y-auto">
              <p className="text-gray-600 mb-8 leading-relaxed">{selectedRecipeData.description}</p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <div className="w-8 h-8 flex items-center justify-center bg-[#FF6B6B]/10 rounded-lg">
                      <i className="ri-shopping-basket-line text-[#FF6B6B]"></i>
                    </div>
                    Ingredientes
                  </h4>
                  <ul className="space-y-2">
                    {selectedRecipeData.ingredients.map((ingredient, index) => (
                      <li key={index} className="flex items-start gap-2 text-gray-700">
                        <i className="ri-checkbox-circle-fill text-green-500 mt-1"></i>
                        <span>{ingredient}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <div className="w-8 h-8 flex items-center justify-center bg-[#FF8E53]/10 rounded-lg">
                      <i className="ri-file-list-3-line text-[#FF8E53]"></i>
                    </div>
                    Modo de Preparo
                  </h4>
                  <ol className="space-y-3">
                    {selectedRecipeData.instructions.map((instruction, index) => (
                      <li key={index} className="flex items-start gap-3 text-gray-700">
                        <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] text-white rounded-full text-xs font-bold">
                          {index + 1}
                        </span>
                        <span>{instruction}</span>
                      </li>
                    ))}
                  </ol>
                </div>
              </div>

              <div className="mt-8 pt-8 border-t border-gray-200">
                <div className="bg-gradient-to-r from-[#FF6B6B]/10 to-[#FF8E53]/10 rounded-2xl p-6">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-xl flex-shrink-0">
                      <i className="ri-lightbulb-line text-xl text-white"></i>
                    </div>
                    <div>
                      <h5 className="font-bold text-gray-900 mb-2">Dica do Chef</h5>
                      <p className="text-sm text-gray-600">
                        Para um bolo ainda mais úmido, deixe esfriar completamente antes de desenformar. Você pode guardar na geladeira por até 5 dias em um recipiente fechado!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Newsletter Modal */}
      {showNewsletter && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
          <div className="bg-white w-full max-w-md rounded-3xl shadow-2xl p-8">
            <div className="text-center mb-6">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-2xl mx-auto mb-4">
                <i className="ri-mail-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                Receba Receitas Grátis
              </h3>
              <p className="text-gray-600">
                Cadastre seu email e receba receitas exclusivas toda semana!
              </p>
            </div>

            {!subscribed ? (
              <form onSubmit={handleNewsletterSubmit} className="space-y-4">
                <div>
                  <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="seu@email.com"
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#FF6B6B] text-sm"
                  />
                </div>
                <button
                  type="submit"
                  className="w-full py-3 bg-gradient-to-r from-[#FF6B6B] to-[#FF8E53] text-white rounded-xl font-bold hover:shadow-lg transition-all cursor-pointer whitespace-nowrap"
                >
                  Quero Receber Receitas
                </button>
                <button
                  type="button"
                  onClick={() => setShowNewsletter(false)}
                  className="w-full py-3 text-gray-600 hover:text-gray-900 cursor-pointer whitespace-nowrap"
                >
                  Agora não
                </button>
              </form>
            ) : (
              <div className="text-center py-8">
                <div className="w-16 h-16 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4">
                  <i className="ri-check-line text-3xl text-green-600"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-2">Cadastro Realizado!</h4>
                <p className="text-gray-600">
                  Você receberá nossas receitas no email cadastrado.
                </p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
